 <template>
     <div class="pd-5">
        <span class="fontbold2">Sign up </span>   
        <div class="has-text-weight-bold mg-t-5 mg-b-5">Create <span class="orange">company</span>  account </div>
        <div id="preview" >
          <label for="uploadfile">
            <div class="circle-img" v-if="file.name && url == null">
               <img  class="haveimg" :src="imgPath+file.name" />
            </div>
            <img v-if="url" class="haveimg" :src="url" />
            <div v-if="!file.name && !url" class="noimg">
              <div class="font">170 x 170</div>
              <div class="circle"></div>
            </div>
          </label>
        </div>
        <input style="display:none"  type="file" id="uploadfile" name="uploadfile" @change="uploadFile($event)">
        <div v-if="statusFile > 0" class="has-text-centered">
          <span v-if="statusFile == 1" class="has-text-success">
              <b-icon
                icon="check"
                pack="fas">
              </b-icon> Upload Success
          </span>
          <span v-if="statusFile == 2" class="has-text-danger">
            <b-icon
              icon="times"
              pack="fas">
            </b-icon> Upload Fail
          </span>
        </div>
        <div style="text-align:center">
          <b-icon pack="fas"  icon="file-upload"  custom-class="fa-cloud-upload-alt mg-x-1 has-text-grey-dark"></b-icon>
          <label for="uploadfile">{{file.name ? file.name : 'No file chosen' | snippetMid}}</label>
        </div>
        <b-field label="Name" > 
            <b-input class="fontnormal" placeholder="Name" v-model="signup.name"></b-input>
        </b-field>
        <b-field label="Surname">
            <b-input class="fontnormal" placeholder="Surname" v-model="signup.surname"></b-input>
        </b-field>
         <b-field label="Email">
            <b-input class="fontnormal" type="email" placeholder="Email" v-model="signup.email"></b-input>
        </b-field>
          <b-field label="Password">
          <b-input type="password"  class="fontnormal" placeholder="Password" v-model="signup.password"></b-input>
        </b-field>
         <b-field label="Re-Password">
            <b-input type="password"  class="fontnormal" placeholder="Re-Password" v-model="repassword"></b-input>
        </b-field>
          <div class="field checkTerm">
            <b-checkbox v-model="tems">By clicking this form you agree with out </b-checkbox> <router-link to="/terms" target="_blank" class="tems is-uppercase">  TERMS AND CONDITIONS.</router-link>
          </div>
         <div class="buttons">
           <!-- @click="gopath('/signupsuccess')" -->
          <a @click="signup_c()"  class="button is-primary buttonc">
            <span class="fontbold">SIGN UP</span>
          </a>
        </div>
       
        <div class="changesignin">
        Already have an account? <a @click="gopath('/signin')" style="color:#FD7900;">SIGN IN here!</a> 
        </div>
     </div>
 </template>
 
<script>
import {HTTP,HTTPMentor,HTTPScan} from "@/axios.js";
import navbarbg from './navbarbg'
// import navbar from './navbar'
export default {
        data() {
            return {
              imgPath:process.env.VUE_APP_IMG_PROFILE,
              statusFile:0,
                signup:{
                  name:'',
                  surname:'',
                  email:'',
                  password:'',
                  userLevel:0,
                   profilePic:'',
                },
                  repassword:'',
                  tems:null,
                  file:{
                    name:''
                  },
                  url:null,
            }
        },
        components:{
          navbarbg
        },
        methods:{

          gopath(val){
             this.$router.push(val)
         },
         ModalSuccess() {
          this.$notification.open({
            duration: 5000,
            message: `Sign up is successful`,
            position: 'is-bottom-right',
            type: 'is-success company',
            hasIcon: true,
            iconPack:'fas',
            icon:"check-square"
          })
        },
         signup_c(){
           if(this.signup.password != this.repassword){
             this.$dialog.alert('<p class="has-text-centered is-size-5">Your Password and Re-password <br> do not match</p>');
             return
           }
           if(!this.tems){
             this.$dialog.alert('<p class="has-text-centered is-size-5">Please agree to our terms of use and privacy policy</p>');
             return
           }
            console.log(this.signup)
           if(this.signup.name && this.signup.surname && this.signup.email && this.signup.password){
            // HTTPMentor.defaults.headers.common.Authorization = `Bearer ${this.token}`;  
            HTTPMentor.post(`create/account`,this.signup)
            .then(res => {
              console.log(res)
              if(res.data.success){
                this.signup = {}
                this.ModalSuccess();
                this.$router.push('/signin')
              }else{
                this.$dialog.alert('<p class="has-text-centered is-size-5">Please check for email duplication</p>');
              }
            })
            .catch(e => {
              this.signup = {}
                console.log("api/add/kpi/error",e);
                this.$dialog.alert('<p class="has-text-centered is-size-5">Please check your network connection</p>');
            });
          }else{
            this.$dialog.alert('<p class="has-text-centered is-size-5">Please type in all required fields</p>');
          }  
        },
           uploadFile(event){
            this.statusFile = 0
            console.log('eventeventeventevent',event.target.files[0])
            var formData = new FormData();
            formData.append("file", event.target.files[0]);
            HTTPMentor.post(`upload/profilePic/`,formData)
            .then(res => {
                console.log("upload/file", res);  
                if (res.data.success) {
                    this.signup.profilePic =  res.data.obj
                    this.url = URL.createObjectURL(event.target.files[0]);
                    this.file.name = event.target.files[0].name
                    this.statusFile = 1
                }else{
                    this.statusFile = 2
                }
            })
            .catch(e => {
                console.log("upload/file/error",e);
                if (this.component.options.multiple === false) {
                    this.statusFile = 0
                }
            });
        },
          senttoFormAccess(){
            console.log("window.location.hostname",window.location.hostname+''+this.$route.path)
            let obj ={
              url:window.location.hostname+''+this.$route.path
            }
            HTTPScan.post(`api/scan/`,obj)
              .then(res => {
                  console.log("api/scan", res);  
              })
              .catch(e => {
                  console.log("api/scan/error",e);
              });
          }
        },
        created(){
           setTimeout(() => {
              window.localStorage.clear();
            }, 100);
            this.$store.commit("clearlogin");
            window.localStorage.removeItem("vuex");
            console.log("this.$route.params.type",this.$route.params.type)
            if (typeof this.$route.params.type !== 'undefined' && this.$route.params.type === 'qr') {
              this.senttoFormAccess()
            } 
        },
}
</script>

<style scoped src="./formsign.css"></style>
<style lang="scss"  scoped>
$blue : rgb(13, 106, 202);
$orange : #FFA800;
$orange-top : rgb(254,147,13);
$orange-bottom:  rgb(254,175,28);
$purple-top: rgb(139,98,228);
$purple-bottom: rgb(122,122,236);

.circle-img{
  width:170px;
  height:170px;
  overflow:hidden;
  display:flex;
  justify-content: center;
  align-content: center;
}
.circle-img img{
  max-width:100%;
}

.tems{
  position: relative;
  bottom: 5px
}
.orange,.tems{
  color: $orange;
}
.buttonc{
  background-image: linear-gradient(rgb(254,147,13), rgb(254,175,28));
  opacity: 0.6;
}
.buttonc:hover{
  opacity: 1;
}
.changesignin{
  margin-bottom: 2rem
}
</style>
